import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {Observable, of, Subject} from 'rxjs';
import {map} from 'rxjs/operators';

import {Cacheable} from 'ts-cacheable';

import {SharedSettings} from '../models/shared-settings';
import {url} from '../helpers/url';

import {Location} from '../models/location';

@Injectable({
    providedIn: 'root'
})
export class LocationLookupService {
    private static readonly cacheObservable = new Subject<void>();

    constructor(private http: HttpClient, private settings: SharedSettings) { }

    @Cacheable({
        cacheBusterObserver: LocationLookupService.cacheObservable,
        maxAge: 5 * 1000
    })
    findLocations(search: string): Observable<Location[]> {
        if (search && search.length)
            return this.http.get<Location[]>(this.settings.apiBaseUrl + url`locations?search=${search}`).pipe(
                map(locs => locs.map(loc => new Location(loc.id, loc.city, loc.state, loc.postalCode, loc.country)))
            );
        else
            return of(<Location[]>[]);
    }
}
